<template>
  <div class="confirm-overlay" v-if="show">
    <div class="confirm-box">
      <h3>{{ title }}</h3>
      <p>{{ message }}</p>

      <div class="btn-row">
        <button class="btn-secondary" @click="$emit('cancel')">
          Cancel
        </button>
        <button class="btn-danger" @click="$emit('confirmAction')">
          Confirm
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    show: Boolean,
    title: String,
    message: String
  }
};
</script>

<style scoped>
.confirm-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.4);
  backdrop-filter: blur(2px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99999;
}
.confirm-box {
  width: 320px;
  background: #fff;
  padding: 22px;
  border-radius: 12px;
  box-shadow: 0 6px 25px rgba(0,0,0,0.15);
  animation: pop 0.25s ease;
}
@keyframes pop { from { transform: scale(.8); opacity:0 } to { transform: scale(1); opacity:1 } }
.btn-row {
  margin-top: 18px;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}
.btn-danger {
  background: #000000;
  color: #fff;
  border: none;
  padding: 8px 14px;
  border-radius: 8px;
  cursor: pointer;
}
</style>
